import React, { Component } from 'react';
import moment from 'moment-timezone';
import { dAPI } from 'appSrc/api';
import { PrimaryButton, TimePicker } from 'appSrc/components/UI';
import DatePicker from 'react-datepicker';
import style from './styles/style.module.css';


class PickDate extends Component {
    constructor( props ) {
        super( props );

        this.duration = moment.duration( 0 );
        this.state = {
            newStart: moment.tz( 'America/Chicago' ),
            selectedDate: new Date(),
            rollOverOption: 'rollOver',
            newSchedules: [],
            endStr: '',
        };
    }
    componentDidMount() {
        this.setStartTime( moment.tz( 'America/Chicago' ).minute( 0 ).second( 0 ).add( 1, 'hour' ) );
    }
    calculateDuration = ( scheduleBlocks ) => {
        let st = scheduleBlocks[ 0 ].st.clone();
        let et = scheduleBlocks[ scheduleBlocks.length - 1 ].et.clone();

        let duration = moment.duration( et.diff( st ) );
        this.duration = duration;
        return duration;
    }
    setStartTime = ( value ) => {
        let state = {
            ...this.state,
            newStart: value,
        };
        let newStart = value.clone().tz( 'America/Chicago' );
        let endTime = newStart.clone().add( this.duration );
        let sameDay = endTime.isSame( newStart, 'day' );

        state.endStr = `This rerun will end at ${ endTime.format( 'hh:mmA z' ) }, the ${ sameDay ? 'same' : 'next' } day.`;

        if( !sameDay ) {
            state.extraDay = true;
        }

        state.newSchedules = this.checkRollover( moment( this.state.selectedDate ), state );
        this.setState( state );
    }
    changeDate = ( date ) => {
        let newSchedules = this.checkRollover( moment.tz( date, 'America/Chicago' ), this.state );

        this.setState( { selectedDate: date, newSchedules } );
    }
    checkRollover = ( dateM, gState ) => {
        let newSchedules = [];

        let schedules = this.props.schedules;
        let key = dateM.format( 'MM/DD/YYYY' );

        if( !schedules[ key ] ) {
            newSchedules = [ key ];
        }
        if( gState.extraDay && gState.rollOverOption == 'rollOver' ) {
            let newKey = dateM.add( 1, 'day' ).format( 'MM/DD/YYYY' );
            if( !schedules[ newKey ] ) {
                newSchedules.push( newKey );
            }
        }

        return newSchedules;
    }
    rollOverSelect = ( e ) => {
        let state = { ...this.state };
        state.rollOverOption = e.target.value;
        state.newSchedules = this.checkRollover( moment( state.selectedDate ), state );
        this.setState( state );
    }
    submit = () =>  {
        this.props.onFetching();

        let date = moment.tz( this.state.selectedDate, 'America/Chicago' );
        let time = this.state.newStart.clone();
        let st = this.props.blocks[ 0 ].st.clone();
        let schedules = this.props.schedules;

        let y, m, d, key;
        y = date.year();
        m = date.month();
        d = date.date();
        key = date.format( 'MM/DD/YYYY' );

        // set the new starting time
        time.year( y ).month( m ).date( d ).second( 0 );
        // get the difference in time between the first airing and the new start
        let diff = time.diff( st );

        let relevantSchedules = [];
        // check to see if there is a schedule for this day.
        if( schedules[ key ] ) {
            // there is, so just grab that schedule id
            relevantSchedules[ 0 ] = schedules[ key ].id;
        } else {
            // there isn't we're going to have to make a new schedule
            relevantSchedules[ 0 ] = this.makeSchedule( key ).then( res => res.id );
        }

        // check if we're doing rollover
        if( this.state.extraDay && this.state.rollOverOption == 'rollOver' ) {
            // if we are, check to see if the next day schedule exists
            let newKey = time.clone().add( 1, 'day' ).format( 'MM/DD/YYYY' );
            if( schedules[ newKey ] ) {
                // it does! yay!
                relevantSchedules[ 1 ] = schedules[ newKey ].id;
            } else {
                // it doesn't. make a new one
                relevantSchedules[ 1 ] = this.makeSchedule( newKey ).then( res => res.id );
            }
        }

        // create a copy of all the transferring blocks
        let newBlocks = this.props.blocks.map( block => ( { ...block } ) );
        newBlocks.forEach( ( block ) => {
            delete block.id;
            delete block.schedule_id;
            //add the diff to each of the blocks
            block.st = block.st.clone().add( diff );
            block.et = block.et.clone().add( diff );
            block.start_time = block.st.format();
            block.end_time = block.et.format();
        } );

        let dayBlocks = newBlocks.filter( block => block.et.isSame( time, 'day' ) );
        let rollOver = newBlocks.filter( block => block.et.isAfter( time, 'day' ) );

        Promise.all( relevantSchedules )
        .then( ( ids ) => {
            let p = [];
            if( ids[0] ) {
                p.push( dAPI.patch( `/admin/dltv/schedules/${ ids[0] }/bulk`, {
                    add: dayBlocks,
                } ) );
            }
            if( ids[ 1 ] ) {
                p.push( dAPI.patch( `/admin/dltv/schedules/${ ids[1] }/bulk`, {
                    add: rollOver,
                } ) );
            }
            return Promise.all( p );
        } )
        .then( () => {
            this.props.onSubmit();
        } );
    }
    makeSchedule = ( key ) => {
        return dAPI.post( '/admin/dltv/schedules', {
            run_date: key,
        } );
    }
    makeBlock = ( schId, block ) => {
        var blockData = { ...block };
        var videoData = { ...block.video };
        delete blockData.video;
        delete videoData.id;
        delete videoData.block_id;

        return dAPI.post( `/admin/dltv/schedules/${ schId }`, {
            video: videoData,
            schedule_block: blockData,
        } );
    }


    render() {
        const { blocks, visible } = this.props;
        const { selectedDate, extraDay } = this.state;

        const newStart = this.state.newStart || moment();
        let duration, durStr;
        if( visible && blocks.length > 0 ) {
            // assume the blocks have already had moment objects attached to them
            blocks.sort( ( a, b ) => {
                return a.st.valueOf() - b.st.valueOf();
            } );
            duration = this.calculateDuration( blocks );
            durStr = moment.utc( duration.as( 'milliseconds' ) ).format( 'HH:mm:ss' );
        }

        const timeProps = {
            use12Hours: true,
            minuteStep: 1,
            showSecond: false,
        };

        return (
            <div className={ style.content }>
                <p>The selected content is expected to cover a { durStr } period.</p>
                <p>When would you like it to start?</p>
                <div className={ style.optionZone }>
                    <div>
                        <p className={ style.fieldTitle }>Date:</p>
                        <DatePicker className={ style.picker }
                        placeholderText="Click to select a date"
                        selected={ selectedDate } onChange={ this.changeDate } />
                    </div>
                    <div className={ style.timeField } >
                        <p className={ style.fieldTitle }>Time:</p>
                        <TimePicker { ...timeProps } value={ newStart }
                        onChange={ ( value ) => { this.setStartTime( value ); } } />
                    </div>
                </div>
                <p>{ this.state.endStr }</p>
                { extraDay &&
                    <div className={ style.extraDay }>
                        <p>Starting at that time causes the schedule to run over to the next day.<br/>
                        How would you like to handle this?</p>
                        <div>
                            <label>
                                <input type='radio' name='extra-day' value='rollOver'
                                checked={ this.state.rollOverOption === 'rollOver' }
                                onChange={ this.rollOverSelect } />
                                Roll over onto the next day
                            </label>
                            <label>
                                <input type='radio' name='extra-day' value='cutOff'
                                checked={ this.state.rollOverOption === 'cutOff' }
                                onChange={ this.rollOverSelect } />
                                Cut off at midnight
                            </label>
                        </div>
                    </div>
                }
                { this.state.newSchedules.length > 0 &&
                    <div className={ style.extraDay }>
                        <p>This will create new schedules for the following days:<br/>
                            { this.state.newSchedules.join( ', ' ) }</p>
                    </div>
                }
                <div className={ style.buttonGroup }>
                    <PrimaryButton label='Submit' onClick={ this.submit } />
                    <PrimaryButton label='Cancel' reverse onClick={ this.props.closeHandler } />
                </div>
            </div>
        );
    }
}
PickDate.defaultProps = {
    blocks: [],
    onFetching: () => {},
    onSubmit: () => {},
};

export default PickDate;
